import styled from 'styled-components';
import { Accordion } from '../../shared/accordion';

export const StyledHeader = styled.p`
    font-family: 'Corporate E';
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
`;

export const StyledVehicleSummary = styled.p`
    font-size: 16px;
    margin-top: 8px;
`;

export const StyledLineItemGrid = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 40px;
`;

export const StyledLineItem = styled.div`
    display: flex;
    padding: 12px 16px 12px 12px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;

    &:nth-child(odd) {
        background-color: #f1f1f2;
    }
`;

export const StyledLineItemValue = styled.span`
    font-weight: 500;
`;

export const StyledTotalMonthly = styled.div`
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e2e2e4;
    font-family: 'Corporate E';
    font-size: 20px;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
`;

export const StyledMonthlyAndTotalGrid = styled.div`
    padding: 12px;
`;

export const StyledInclServiceDisclaimer = styled.p`
    font-size: 12px;
    font-weight: 500;
    text-align: right;
    color: #676767;
`;

export const StyledTotalInPeriod = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
    margin-top: 20px;
`;

export const StyledEstablishmentFeeSummary = styled.div`
    font-size: 12px;
    color: #676767;
`;

export const StyledEstablishmentFeeCollapsedSummary = styled.div<{ hide: boolean }>`
    position: absolute;
    padding-top: 4px;
    right: 0;
    top: 0;
    font-size: 12px;
    color: #676767;
    opacity: ${(props) => (props.hide ? 0 : 1)};
    transition: all 0.2s ease-in-out;
`;

export const StyledAccordion = styled(Accordion)`
    font-size: 12px;

    & > div {
        justify-content: flex-start;

        & > div {
            padding-top: 0;
        }
    }
`;

export const StyledEstablishmentFeeSummaryGrid = styled.div`
    position: relative;
    margin-top: 6px;
`;

export const StyledEstablishmentFeeSummaryLineItemGrid = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 12px;
    padding-top: 24px;
`;

export const StyledModalContentContainer = styled.div`
    border-top: 1px solid #e2e2e4;
    margin-top: 40px;
    padding-top: 40px;
`;
